export const LOADING_CARD = "LoadingCard";
export const LOADING_CIRCULAR_PROGRESS = "LoadingCirculerProgress";
